import React from "react";
import styled from "styled-components";
import { Bio } from "../../data/constanit";
import { ArrowUp } from "lucide-react";
import {
  FaGithub as Github,
  FaLinkedin as Linkedin,
  FaInstagram as Instagram,
  FaFacebook as Facebook
} from "react-icons/fa";

const FooterContainer = styled.footer`
  width: 100%;
  padding: 60px 24px 30px;
  display: flex;
  justify-content: center;
  border-top: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.bgLight};
  position: relative;
  z-index: 1;
`;

const FooterWrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  color: ${({ theme }) => theme.text_primary};
`;

const LogoBox = styled.a`
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  font-size: 24px;
  font-weight: 800;
  color: ${({ theme }) => theme.text_primary};

  span {
    color: #06b6d4;
  }
`;

const Tagline = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.text_secondary};
  text-align: center;
  max-width: 480px;
  line-height: 1.6;
`;

const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 28px;
  flex-wrap: wrap;
  justify-content: center;
  margin: 10px 0;
`;

const NavLink = styled.a`
  color: ${({ theme }) => theme.text_secondary};
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
  transition: color 0.2s ease;

  &:hover {
    color: #06b6d4;
  }
`;

const SocialIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const SocialIconButton = styled.a`
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  background: ${({ theme }) => theme.card_light};
  border: 1px solid ${({ theme }) => theme.border};
  color: ${({ theme }) => theme.text_secondary};
  text-decoration: none;
  transition: all 0.25s ease;

  &:hover {
    color: #06b6d4;
    border-color: #06b6d4;
    background: rgba(6, 182, 212, 0.1);
    transform: translateY(-3px);
  }
`;

const BackToTopButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 999px;
  background: ${({ theme }) => theme.bgSoft};
  border: 1px solid ${({ theme }) => theme.border};
  color: ${({ theme }) => theme.text_secondary};
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    color: #06b6d4;
    border-color: #06b6d4;
    transform: translateY(-2px);
  }
`;

const BottomRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 24px;
  border-top: 1px solid ${({ theme }) => theme.border};
  font-size: 13px;
  color: ${({ theme }) => theme.text_muted};
  flex-wrap: wrap;
  gap: 12px;

  @media (max-width: 640px) {
    justify-content: center;
    text-align: center;
  }
`;

function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <FooterContainer>
      <FooterWrapper>
        <LogoBox href="#about">
          Vivek<span>.dev</span>
        </LogoBox>

        <Tagline>
          Crafting exceptional digital experiences, interactive 3D interfaces, and high-performance full-stack architectures.
        </Tagline>

        <Nav>
          <NavLink href="#about">About</NavLink>
          <NavLink href="#skills">Skills</NavLink>
          <NavLink href="#dsa">DSA</NavLink>
          <NavLink href="#experience">Experience</NavLink>
          <NavLink href="#projects">Projects</NavLink>
          <NavLink href="#education">Education</NavLink>
          <NavLink href="#contact">Contact</NavLink>
        </Nav>

        <SocialIcons>
          {Bio.github && (
            <SocialIconButton
              href={Bio.github}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub"
            >
              <Github size={18} />
            </SocialIconButton>
          )}
          {Bio.linkedin && (
            <SocialIconButton
              href={Bio.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <Linkedin size={18} />
            </SocialIconButton>
          )}
          {Bio.insta && (
            <SocialIconButton
              href={Bio.insta}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <Instagram size={18} />
            </SocialIconButton>
          )}
          {Bio.facebook && (
            <SocialIconButton
              href={Bio.facebook}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <Facebook size={18} />
            </SocialIconButton>
          )}
        </SocialIcons>

        <BackToTopButton onClick={scrollToTop}>
          <ArrowUp size={14} /> Back to top
        </BackToTopButton>

        <BottomRow>
          <span>&copy; {new Date().getFullYear()} {Bio.name}. All rights reserved.</span>
          <span>Designed & Engineered for High Performance</span>
        </BottomRow>
      </FooterWrapper>
    </FooterContainer>
  );
}

export default Footer;
